import { Container } from "@mantine/core"
import { createFileRoute, Outlet } from "@tanstack/react-router"

import { PageHeader } from "@/components/PageHeader"

export const Route = createFileRoute("/hub")({
  component: Hub,
})

function Hub() {
  return (
    <Container size="xl">
      <PageHeader eyebrow="Records">Corporate Hub</PageHeader>
      <Outlet />
    </Container>
  )
}
